import Api from '@silbo/core';
import { initializeApp } from '@firebase/app';
import { isNotificationSupported, retrieveAndStoreFcmToken, subscribeToNotifications } from './notification';
import { datadogLogs } from '@datadog/browser-logs';

export const vapidKey = 'BNzzAggNxmOojT02qwgki86L4FmcISXnaGKEKFhpbeKFWgv-BD8lKCH3bci7N1QucvHWowVR1ezyp7v20FRePmc';

const firebaseConfig = {
  apiKey: 'AIzaSyALas5seudUODEpU_fS9mq_rj4kGRV3Ipk',
  authDomain: 'hello-silbo.firebaseapp.com',
  projectId: 'hello-silbo',
  storageBucket: 'hello-silbo.firebasestorage.app',
  messagingSenderId: '388253311039',
  appId: '1:388253311039:web:371106f28bd330bd7b988a',
  measurementId: 'G-9C78TZZPFC',
};

export function initFirebase() {
  return initializeApp(firebaseConfig);
}

export function initFcm() {
  try {
    datadogLogs.logger.debug('Initializing FCM', {
      isNotificationSupported: isNotificationSupported(),
      hasCurrentUser: !!Api.User.current(),
      notificationPermission: typeof Notification !== 'undefined' ? Notification.permission : 'unavailable',
      userAgent: navigator.userAgent,
    });

    initFirebase();
    subscribeToNotifications();
    // https://firebase.google.com/docs/cloud-messaging/manage-tokens
    if (isNotificationSupported() && Api.User.current() && Notification.permission === 'granted') {
      retrieveAndStoreFcmToken();
    } else {
      datadogLogs.logger.warn('FCM token retrieval skipped', {
        isNotificationSupported: isNotificationSupported(),
        hasCurrentUser: !!Api.User.current(),
        notificationPermission: typeof Notification !== 'undefined' ? Notification.permission : 'unavailable',
      });
    }
  } catch (error) {
    datadogLogs.logger.error('FCM initialization failed', { error: error?.message }, error);
  }
}
